import React from 'react';
import { Helmet } from 'react-helmet-async';
import HowItWorksSection from './HowItWorks';
import WhyChooseUs from './WhyChooseUs';
import { ArrowRight, BatteryCharging } from 'lucide-react';


const HomePage = ({ setPage }) => {
    // App store links
    const playStoreLink = "https://play.google.com/store/apps/details?id=com.niloy.peerchargerev&pcampaignid=web_share";

    return (
        <div className="bg-[#fafcfa] min-h-screen">
            <Helmet>
                <title>PeerChargeEV | India's P2P EV Charging Network & Host Sharing</title>
                <meta name="description" content="Find verified peer-to-peer (P2P) EV chargers across India or earn money by sharing your home EV charger. Download the PeerChargeEV app today." />
            </Helmet>

            {/* Hero Section */}
            <section className="pt-24 pb-20 overflow-hidden relative">
                {/* Background decorative elements */}
                <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-brand-green/5 rounded-full blur-3xl"></div>
                <div className="absolute bottom-[-10%] right-[-5%] w-[30%] h-[40%] bg-brand-green/5 rounded-full blur-3xl"></div>

                <div className="container mx-auto px-6 relative z-10">
                    <div className="text-center max-w-4xl mx-auto mb-16">
                        {/* Rating pill or intro badge */}
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-gray-100 shadow-sm text-sm font-medium text-gray-600 mb-8">
                            <span className="flex text-yellow-400">★★★★★</span>
                            Trusted by 10,000+ EV Owners
                        </div>

                        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight text-gray-900 tracking-tight mb-6">
                            India's Leading Peer-to-Peer (P2P) <span className="text-brand-green">EV Charging Network</span>
                        </h1>
                        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed">
                            Find affordable home chargers in your neighborhood, or earn money by sharing your own. Welcome to the future of charging.
                        </p>

                        <div className="flex justify-center items-center gap-4">
                            <a
                                href={playStoreLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-brand-green hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all flex items-center gap-2 shadow-xl shadow-brand-green/25"
                            >
                                Get Started <ArrowRight size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Hero Graphic Composition */}
                    <div className="relative max-w-4xl mx-auto mt-12">
                        {/* Decorative glow behind the video */}
                        <div className="absolute -inset-1 bg-gradient-to-r from-brand-green to-emerald-300 blur-xl opacity-30"></div>
                        
                        {/* Video Frame */}
                        <div className="relative shadow-2xl overflow-hidden">
                            <div className="aspect-video bg-gray-900 relative">
                                <iframe
                                    className="absolute inset-0 w-full h-full border-0"
                                    src="https://www.youtube-nocookie.com/embed/IYto4T7nwD4?autoplay=1&mute=1"
                                    title="PeerChargeEV how it works? - Hindi"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <HowItWorksSection />
            <WhyChooseUs />
        </div>
    );
};

export default HomePage;